// components/GxBlackButton/GxBlackButton.tsx
import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import Spinner from "../loader/ButtonSpinner";

export interface GxBlackButtonProps {
  /** Click handler */
  onClick: () => void;

  /** Button text */
  children?: React.ReactNode;

  /** Loading state */
  loading?: boolean;

  /** Disabled state */
  disabled?: boolean;

  /** Button type */
  type?: "button" | "submit" | "reset";

  /** Custom label to show during loading state */
  loadingLabel?: string;
}

const GxBlackButton: React.FC<GxBlackButtonProps> = ({
  onClick,
  children,
  loading = false,
  disabled = false,
  type = "button",
  loadingLabel,
}) => {
  const handleClick = () => {
    if (!loading && !disabled) {
      onClick();
    }
  };

  const getButtonText = () => {
    if (loading) {
      return loadingLabel || children || "";
    }
    return children || "";
  };

  return (
    <Button
      onClick={handleClick}
      disabled={disabled || loading}
      type={type}
      className="gx-dialog-button-black-small gx-submit-for-approval-small"
    >
      {loading && <Spinner />}
      <span className="gx-p12-eb">{getButtonText()}</span>
    </Button>
  );
};

export default GxBlackButton;
